/**
 * 認證 / 2FA 相關的後端業務碼（body.code）
 */
export enum AuthErrorCodeEnum {
	/**
	 * 1000003 在 admin 路徑只出現在 2FA setup、verify、logout 的轉發，其他 admin 路由的失效 token 回 1000004，前端應清 token 回登入頁
	 * logout 在 MEB 回報該管理員的 2FA 已被重置（1036）時也回 1000003，前端視為已登出
	 * MEB 的 45、95 不會從 2FA 路由的認證層出來，實務上不可達，映射只是保留
	 * 原因與 MEB 出處見 libs/shared-rust/src/middleware/auth/README.md 的「MEB errno vs SunCake ErrCode 是不同層」一節
	 */
	Token = 1000003,
	/**
	 * 權限不足 / 驗證失敗，admin 路徑上代表 MEB 回報 token 無效、過期或已列入黑名單，其他 MEB 錯誤與暫時性失敗改回 1000011，登出時視為已登出，前端應清 token 回登入頁
	 */
	Forbidden = 1000004,
	/**
	 * 尚未完成 2FA（token 未帶 tfa=true），前端應導向 2FA 頁
	 */
	TwoFaRequired = 1000008,
	/**
	 * 2FA 驗證碼錯誤（MEB errno 1035），暫時 token 仍有效可重試
	 * MEB 驗碼失敗分支回 1035 時沒有呼叫 invalidate，出處是 service-license-api 的 origin/feature#1422-ha 分支 app/Services/v1/admin/AdminUserService.php:284-293
	 */
	TwoFaCodeInvalid = 1000009,
	/**
	 * 2FA 嘗試次數過多被鎖定 15 分鐘（MEB errno 1162）
	 * 出處是 service-license-api 的 origin/feature#1422-ha 分支 app/Services/v1/admin/AdminUserService.php:290 的 Cache::put($lockKey, true, 900)
	 */
	TwoFaLocked = 1000010,
	/**
	 * 認證服務暫時無法使用，MEB 逾時、HTTP 非 2xx、回應不完整或其他內部錯誤；前端保留登入狀態並提示稍後再試
	 * 前端 axios 逾時、無回應的網路錯誤與 HTTP 5xx 也由 client.ts 的 withTransportErrors 轉成此碼
	 */
	AuthUnavailable = 1000011,
}
